import React from "react";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import Product from "../market/products/Product";

import ReactWOW from "react-wow";
import Ajax, { domain } from "../ajax/Ajax";
import order from "../images/screenshots/order.png";

class MarketAd extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ready: false,
      products: [],
      location: null,
      failedLocation: false,
      initialFetchMade: false,
    };

    this.owlcarousel = React.createRef();

    this.setLocation = this.setLocation.bind(this);
    this.fetchProducts = this.fetchProducts.bind(this);
  }

  setLocation(location) {
    if (location) {
      this.setState({
        location: location,
      });
    } else {
      this.setState({
        failedLocation: true,
      });
    }
  }

  async fetchProducts() {
    let param = "";
    if (this.state.location) {
      param = `lat=${this.state.location.lat}&lon=${this.state.location.lon}`;
    }

    let fetchResults = await Ajax.fetchData(
      domain + "/en/api/global-search/market/?" + param
    );
    console.log(fetchResults, "the fetch results");

    if (fetchResults) {
      await this.setState({
        products: fetchResults.results,
        ready: true,
        initialFetchMade: true,
      });
    }
  }

  async componentDidMount() {
    //getLocation(this.setLocation)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // if((this.state.location || this.state.failedLocation) && !this.state.initialFetchMade){
    //     this.fetchProducts()
    // }
  }

  render() {
    let products = this.state.products;
    return (
      <div>
        <div>
          <br />
          <br />
          <br />
          <br />
        </div>
        <div className="market-add">
          <div>
            <div className="has-text-centered is-size-5 has-text-grey">
              AS A PERSON
            </div>
          </div>
          <div>
            <br />
            <br />
            <br />
          </div>
          <div className="columns animated slideInUp">
            <div className="column is-1"></div>
            <div className="column is-5 d-flex justify-content-center align-items-center">
              <div className="">
                <h1 className="is-size-3 mt-4">
                  SKIP THE QUEUE AND SHOP ONLINE
                </h1>

                <div className="mt-4 is-size-5 has-text-info">
                  <i>From Any Store Around You.</i>
                </div>

                <div className="mt-4">
                  <Link to="/market/home/">
                    <button className="button">
                      <span className="zmdi zmdi-play mr-2"></span>
                      <span>Start Shopping</span>
                    </button>
                  </Link>
                </div>
              </div>
            </div>
            {this.state.ready && this.state.products.length > 0 ? (
              <div className="mt-4 column is-4 animated fadeIn">
                <div className="columns">
                  <div className="column is-1 d-flex align-items-center justify-content-center">
                    <div className="is-hidden">
                      <button
                        title="Backward"
                        onClick={() => {
                          this.owlcarousel.current.prev();
                        }}
                        className="button is-white is-round"
                      >
                        <span className="fas fa-angle-left"></span>
                      </button>
                    </div>
                  </div>

                  <div className="column is-10">
                    <OwlCarousel
                      ref={this.owlcarousel}
                      className="owl-theme"
                      loop
                      animateIn="fadeIn"
                      animateOut="fadeOut"
                      dots={false}
                      autoplay
                      items={1}
                      margin={30}
                      responsive={{
                        0: {
                          items: 1,
                        },
                        600: {
                          items: 1,
                        },
                        1000: {
                          items: 1,
                        },
                      }}
                      autoplayHoverPause
                    >
                      {products.map((product, i) => (
                        <Product product={product} key={i + "-product"} />
                      ))}
                    </OwlCarousel>
                  </div>

                  <div className="column is-1 d-flex align-items-center justify-content-center">
                    <div className="is-hidden">
                      <button
                        title="Forward"
                        onClick={() => {
                          this.owlcarousel.current.next();
                        }}
                        className="button is-white is-round"
                      >
                        <span className="fas fa-angle-right"></span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="mt-4 column is-5 d-flex align-items-center justify-content-center">
                <div className="animated slideInRight">
                  <img src={order} alt="" />
                </div>
              </div>
            )}
          </div>
        </div>
        <div>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
        <div className="market-bg has-background-info">
          <div className="container market-padding has-text-white has-text-centered">
            <div className="is-size-2">
              <span className="zmdi zmdi-gps mr-2"></span>{" "}
            </div>

            <div className="title">
              <div className="has-text-white">
                Know the Closest Store to Best Buy what you Need.
              </div>
            </div>

            <ReactWOW animation="slideInUp">
              <div className="mt-2">
                <Link to="/market/">
                  <button className="button is-link is-flat">
                    <span className="zmdi zmdi-gps mr-2"></span>
                    Find your store
                  </button>
                </Link>
              </div>
            </ReactWOW>
          </div>
        </div>
      </div>
    );
  }
}

export default MarketAd;
